export default {
  id: null,
  nome: null,
  periodicidade: null,
  periodicidadeDias: null,
  exibirEmDiversos: false,
  exibirEmViagemAdm: null,
  exibirEmReembolsoGeral: null,
  descricao: null,
  status: null,
  dateUpdate: null,
  accountIDUpdate: null
}



// WEBPACK FOOTER //
// ./src/shared/models/configuration/travelreason.js